export const commonTypes = {
  SET_SIDEBAR: 'SET_SIDEBAR',
  SET_COLLAPSE_SIDEBAR: 'SET_COLLAPSE_SIDEBAR',
  SET_SHOW_SECOND_BURGER: 'SET_SHOW_SECOND_BURGER',
};

export type ICommonState = Readonly<{
  showNavbar: boolean;
  showSecondBurger: boolean;
  showSidebar: boolean;
  collapseSidebar: boolean;
}>;
